import api from '../../services/api';

export const getPagamentosByVendaId = async (id) => {
    try {
        const response = await api.get(`/pagamentos/${id}`);
        return response.data; // Retorna os dados do status
    } catch (error) {
        console.error('Erro ao buscar Pagamento por Venda ID:', error);
        throw error; // Lança o erro para tratamento em outro lugar
    }
};
